import {useQuery} from "@tanstack/react-query";
import {getSelfCustomAvatarHistory} from "./index";

// eslint-disable-next-line import/prefer-default-export
export const useSelfCustomAvatarHistoryQuery = (workspaceId: number, options = {}) =>
    useQuery({
        queryKey: ['selfCustomAvatarHistory', workspaceId],
        queryFn: () => getSelfCustomAvatarHistory(workspaceId),
        enabled: !!workspaceId,
        staleTime: 0,
        ...options,
    });
